import * as React from "react";
import { Box, Grid, Select, MenuItem, FormControl } from "@mui/material";

export default function DropDownSelect({ question, onAnswer = () => {} }) {
  const getInitialAnswerState = React.useCallback(() => {
    const keys = Object.keys(question.answer.value);
    const initialState = {};
    keys.forEach((key) => {
      initialState[key] = null;
    });
    return initialState;
  }, [question.answer.value]);

  const [selectedAnswer, setSelectedAnswer] = React.useState(
    getInitialAnswerState()
  );

  React.useEffect(() => {
    setSelectedAnswer(getInitialAnswerState());
  }, [question, getInitialAnswerState]);

  const handleSetAnswer = (key, value) => {
    const updatedAnswers = {
      ...selectedAnswer,
      [key]: value,
    };

    setSelectedAnswer(updatedAnswers);
    onAnswer({
      canProceed: true,
      answer: updatedAnswers,
    });
  };

  // Filter to get only the events that should have a value (non-null)
//   const eventKeys = Object.keys(question.answer.value).filter(
//     (key) => question.answer.value[key] !== null
//   );

  const choices = question.questionList.choices.map((choice) =>
    choice.value.trim().replace(/\u200B/g, "")
  );

  return (
    <React.Fragment>
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <img
          src={question.questionImage}
          alt="question"
          style={{ maxWidth: "100%" }}
        />
      </Box>
      <Box className="choices-container" sx={{ px: 4, textAlign: "center" }}>
        {(Object.entries(question.questionList.events) || {}).map((key, i) => (
          <Grid container sx={{ mt: 2 }} key={i} alignItems="center">
            <Grid item sm={4} xs={12} sx={{ textAlign: "left" }}>
              <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                <Box
                  sx={{
                    flex: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                    {key[1].value}
                </Box>
              </Box>
            </Grid>
            <Grid item sm={8} xs={12}>
              <Box sx={{ pl: { sm: 2, xs: 0 }, pt: { xs: 2, sm: 0 } }}>
                <FormControl fullWidth variant="outlined" size="small">
                  <Select
                    value={selectedAnswer[key[1].index] || ''} // Initialize as empty
                    onChange={(e) => handleSetAnswer(key[1].index, e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Date
                    </MenuItem>
                    {choices.map((choice, index) => (
                      <MenuItem key={index} value={choice}>
                        {choice}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>
        ))}
      </Box>
    </React.Fragment>
  );
}
